import React, {useCallback, useEffect, useState} from 'react';
import {
  // IconCheckCircleFill,
  IconChevronLeft,
  IconChevronRight,
  // IconClockFill,
  // IconPlus,
  IconSpinner,
  // IconXCircleFill,
} from "../../../components/icons";
// import StatusBadge from "../../../components/common/StatusBadge";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import DossierForm from "./components/DossierForm";
import FicheForm from "./components/FicheForm";
import {getAllEtatChocs, getDossierById} from "../../../components/requests";
import {
  // Depositaire,
  Dossier,
  // Enlevement,
  Frais,
  // Proprietaire,
  // Sinistre
} from "../../../components/models";
import {formatDate, getSourceReferencePrefix} from "../../../components/helpers";
import {SourceLogo} from "../../../components/common/SourceLogo";

const DossierGestionPage = () => {
  const {id} = useParams();
  // const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isSecondaire,
    currentPage,
    dateAfter,
    dateBefore,
    source,
    reference,
    proprietaire,
    immatriculation,
    marque,
    modele,
    referencePartenaire,
    partenaire,
    statut,
    dossierData,
  } = location.state || {};
  const [activeContent, setActiveContent] = useState<string>('dossier'); // dossier / fiche
  const [dossier, setDossier] = useState<Dossier | null>(dossierData ? dossierData : null);
  const [fraisComplet, setFraisComplet] = useState<Frais | null>(null);
  const [etats, setEtats] = useState<string[]>([]);
  const [chocs, setChocs] = useState<string[]>([]);
  // const API_URL = process.env.REACT_APP_API_URL;
  // const allowedTypes = [
  //   "image/png",
  //   "image/jpeg",
  //   "application/pdf",
  //   "application/zip",
  //   "application/x-rar-compressed",
  // ];

  // Conservation des données en state pour le bouton retour vers la liste des dossiers
  const searchFilter = {
    isSecondaire: isSecondaire,
    currentPage: currentPage,
    dateAfter: dateAfter,
    dateBefore: dateBefore,
    source: source,
    reference: reference,
    proprietaire: proprietaire,
    immatriculation: immatriculation,
    marque: marque,
    modele: modele,
    referencePartenaire: referencePartenaire,
    partenaire: partenaire,
    statut: statut,
  };

  // Méthode d'obtention des détails d'un dossier spécifique
  const getDossierDetail = useCallback((id: string) => {
    if (!dossier) {
      getDossierById(id)
        .then((response) => {
          if (response.status === 200 && response.data !== undefined) {
            setDossier(response.data);
          }
        })
        .catch((error) => console.error(error))
        .finally(() => null);
    }
  }, [dossier]);

  const getListEtatChocs = useCallback(() => {
    getAllEtatChocs()
      .then((response) => {
        if (response.status === 200 && response.data !== undefined) {
          setEtats(response?.data?.data?.filter(etat => etat.type === "Etat")?.map(etat => etat.libelle));
          setChocs(response?.data?.data?.filter(choc => choc.type === "Choc")?.map(choc => choc.libelle));
        }
      })
      .catch((error) => console.error(error))
      .finally(() => null);
  }, []);

  // Méthode pour vérifier si les frais sont complétés ou pas
  const getStatusFrais = (obj: any): "completed" | "incompleted" => {
    if (!obj) return "incompleted";
    const filteredValues = Object.entries(obj)
      .filter(([key]) => key !== "@id" && key !== "@type" && key !== "id" && key !== "brouillon")
      .map(([, value]) => value);

    const hasValidValue = filteredValues.some((val) => {
      if (val === null || val === undefined) return false;
      if (val === 0) return false;
      return val !== "";
    });

    return hasValidValue ? "completed" : "incompleted"
  }

  // Méthode d'affichage des progressions individuels
  // Sinistre, Propriétaire, Dépositaire, Enlèvement, Frais
  // const displayProgession = (label: any | null, nom: string) => {
  //   let status = 'completed'
  //   if (nom === 'Sinistre' && !label?.immatriculation) status = 'incompleted'
  //   if ((nom === 'Propriétaire' || nom === 'Dépositaire') && !label?.nom) status = 'incompleted'
  //   if (nom === 'Enlèvement' && !label?.dateOuvertureDossier) status = 'incompleted'
  //   if (nom === 'Frais') status = getStatusFrais(label)
  //   if (label && status === 'completed') {
  //     return (
  //       <div className="flex items-center gap-1.5 text-green-600">
  //         <IconCheckCircleFill className="w-3.5 h-3.5"/>
  //         {nom} complété
  //       </div>
  //     );
  //   }
  //   // else if (label && label.brouillon === true) {
  //   //   return (
  //   //     <div className="flex items-center gap-1.5 text-amber-600">
  //   //       <IconClockFill className="w-3.5 h-3.5"/>
  //   //       {nom} en cours
  //   //     </div>
  //   //   );
  //   // } else {
  //   //   return (
  //   //     <div className="flex items-center gap-1.5 text-gray-400">
  //   //       <IconXCircleFill className="w-3.5 h-3.5"/>
  //   //       {nom} à compléter
  //   //     </div>
  //   //   );
  //   // }
  // }

  // Méthode de calcul de la progression globale
  // const calculateProgression = () => {
  //   let increment: number = 0;
  //
  //   if (sinistreComplet && sinistreComplet.brouillon === false) increment++;
  //   if (proprietaireComplet && proprietaireComplet.brouillon === false) increment++;
  //   if (depositaireComplet && depositaireComplet.brouillon === false) increment++;
  //   if (enlevementComplet && enlevementComplet.brouillon === false) increment++;
  //   if (fraisComplet && fraisComplet.brouillon === false) increment++;
  //
  //   return (increment * 100) / 5;
  // };

  // useEffect pour l'obtention des détails d'un dossier
  useEffect(() => {
    if (id) getDossierDetail(id)
  }, [id, getDossierDetail]);

  useEffect(() => {
    getListEtatChocs();
  }, [getListEtatChocs]);


  // const handleFileChange = async (e) => {
  //   const file = e.target.files[0]
  //   const formData = new FormData()
  //   formData.append('file', file)
  //   if (!file) return
  //
  //   if (!allowedTypes.includes(file.type)) {
  //     toast.error("Type de fichier non autorisé")
  //     e.target.value = null
  //     return
  //   } else {
  //     const response = await addDocument(dossier.id, formData)
  //     if (response.status === 201) {
  //       toast.success("Fichier ajouté avec succès!")
  //     } else {
  //       toast.error("Erreur lors de l'ajout du fichier!")
  //     }
  //   }
  // }

  // Pour afficher uniquement les lettres en capital de l'état et le choc en gardant les retours à la ligne
  const formatEtatChoc = useCallback((text: string, type?: string) => {
    const lines = text.replace("_x000d_", "\n").replace("_x000A_", "\n").split("\n")
    const capitalLines = lines.map(line => {
      const capitalWords = line.match(/\b[A-Z]+\b/g)
      if (etats.length > 0 || chocs.length > 0) {
        let filteredWords = capitalWords?.filter(
          capital => ((type && type === "etat") ? etats : chocs).includes(capital)
        );
        return filteredWords?.join(" ") ?? ""
      }
      return capitalWords?.join(" ") ?? ""
    })
    return capitalLines.join("\n")
  }, [etats, chocs]);

  if (!dossier) {
    return (
      <div className="flex items-center justify-center min-h-screen-fit">
        <IconSpinner className="animate-spin w-10 h-10"/>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen-fit">
      {/* Deuxième header début */}
      <header className="bg-white top-0 border-b border-gray-200 sticky z-20">
        <div className="mx-auto px-4">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate('/dossiers', {state: searchFilter, replace: true})}
                className="p-1.5 hover:bg-gray-100 rounded-lg"
              >
                <IconChevronLeft className="w-6 h-6"/>
              </button>
              <div>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <span>Dossiers</span>
                  <IconChevronRight className="w-3 h-3"/>
                  <span className="text-gray-900 font-medium">
                    {getSourceReferencePrefix(dossier?.source?.libelle)}
                    {dossier.reference}
                  </span>
                </div>
                <h1 className="text-base font-bold text-gray-900">
                  {(dossier?.vehicule?.marque ?? '') + " / " + (dossier?.vehicule?.modele ?? '')}
                  {" • "}
                  <span className="text-green-600">
                    {dossier?.vehicule?.immatriculation}
                  </span>
                </h1>
              </div>
            </div>
            <div>
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <span>
                  <SourceLogo source={dossier.source.libelle} classExtra='w-14 h-14'/>
                </span>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-sm">
                <span className="text-gray-500">
                  Partenaire: <span className="font-semibold">{dossier?.partenaire?.nom}</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </header>
      {/* Deuxième header fin */}

      <div className="sub-container mx-auto p-4">
        <div className="flex gap-4">
          {/* Main Tabs début */}
          <div className="w-[calc(100%-370px)]">
            {/* Bouton Main Tabs début */}
            <div className="flex gap-2 mb-4">
              <button
                onClick={() => setActiveContent('dossier')}
                className={`px-4 py-2 rounded-lg text-sm font-medium ${activeContent === 'dossier' ? 'bg-green-600 text-white' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'}`}
              >
                📋 Gestion du dossier
              </button>
              <button
                onClick={() => setActiveContent('fiche')}
                className={`px-4 py-2 rounded-lg text-sm font-medium ${activeContent === 'fiche' ? 'bg-green-600 text-white' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'}`}
              >
                🚗 Fiche véhicule
              </button>
            </div>
            {/* Bouton Main Tabs fin */}

            {/* Content Main Tabs début */}
            <div className={`rounded-xl ${activeContent === 'dossier' && 'bg-white shadow-sm'}`}>
              {(activeContent === 'dossier') && <DossierForm
                  dossier={dossier}
                  setFraisComplet={setFraisComplet}
                  formatEtatChoc={formatEtatChoc}
                  getStatusFrais={getStatusFrais}
                  etats={etats}
                  chocs={chocs}
              />}
              {(activeContent === 'fiche') && <FicheForm dossier={dossier} formatEtatChoc={formatEtatChoc}/>}
            </div>
            {/* Content Main Tabs fin */}
          </div>
          {/* Main Tabs fin */}

          {/* Side section début */}
          <div className="w-96 top-[145px] right-0 mx-4 flex-shrink-0 space-y-4">
            {/* Etat du dossier début */}
            <div className="bg-white rounded-xl shadow-sm p-4">
              <div className="flex items-center justify-between">
                <h4 className="text-gray-900 text-sm">Etat du dossier :</h4>
                <h4 className="font-semibold text-gray-900 text-sm">{dossier?.statut?.libelle}</h4>
              </div>
            </div>
            {/* Etat du dossier fin */}

            {/* Récapitulatif du dossier début */}
            <div className="bg-white rounded-xl shadow-sm p-4">
              <h4 className="font-semibold text-gray-900 text-sm mb-3">
                Récapitulatif du dossier
              </h4>

              <div className="flex">
                {/* Colonne timeline */}
                <div className="mr-4 flex flex-col items-center pt-2">
                  {/* rond 1 */}
                  <div className="h-3 w-3 rounded-full border border-gray-500 bg-white"/>
                  <div className="h-[136px] w-px bg-gray-500"/>
                  {/* rond 2 */}
                  <div className="h-3 w-3 rounded-full border border-gray-500 bg-white"/>
                  <div className="h-[88px] w-px bg-gray-500"/>
                  {/* rond 3 */}
                  <div className="h-3 w-3 rounded-full border border-gray-500 bg-white"/>
                  <div className="h-6 w-px bg-gray-500"/>
                  {/* flèche bas */}
                  <div className="relative h-6 w-px bg-gray-500">
                    <div
                      className="absolute left-1/2 top-full -translate-x-1/2 border-x-4 border-t-4 border-x-transparent border-t-gray-500"/>
                  </div>
                </div>

                {/* Colonne contenu */}
                <div className="flex-1 text-xs text-gray-700 space-y-4">
                  {/* Bloc 1 */}
                  <div>
                    <h4 className="flex justify-between font-semibold text-gray-400 text-sm mb-2">
                      <span>Création du dossier le:</span>
                      <span className="font-bold text-gray-700">
                        {formatDate(dossier?.enlevements?.[0]?.dateOuvertureDossier) || "N/C"}
                      </span>
                    </h4>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span className="text-sky-500">Type sinistre</span>
                        <span className="text-right text-gray-500">
                          {dossier?.sinistres?.[0]?.typeSinistre}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sky-500">Nom Propriétaire</span>
                        <span className="text-right text-gray-500">
                          {dossier?.proprietaires?.[0]?.nom}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sky-500">Nom Dépositaire</span>
                        <span className="text-right text-gray-500">
                          {dossier?.depositaires?.[0]?.nom}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sky-500">Nom Expert</span>
                        <span className="text-right text-gray-500">
                          {dossier?.sinistres?.[0]?.expert}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="h-px bg-gray-200"/>

                  {/* Bloc 2 */}
                  <div>
                    <h4 className="flex justify-between font-semibold text-gray-400 text-sm mb-2">
                      <span>Enlèvement effectif le:</span>
                      <span className="font-bold text-gray-700">
                        {formatDate(dossier?.enlevements?.[0]?.dateEnlevementEffective) || "N/C"}
                      </span>
                    </h4>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span className="text-sky-500">Frais</span>
                        <span className="text-right text-gray-500">
                          {getStatusFrais(fraisComplet) === "completed" ? "Oui" : "Non"}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sky-500">Date d'entrée</span>
                        <span className="text-right text-gray-500">
                          {formatDate(dossier?.enlevements?.[0]?.dateEntree) || "N/C"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="h-px bg-gray-200"/>

                  {/* Bloc 3 */}
                  <div>
                    <h4 className="flex justify-between font-semibold text-gray-400 text-sm mb-2">
                      <span>Cession du véhicule</span>
                      <span className="font-bold text-gray-700">
                        {formatDate(dossier?.dateMiseADispo) || "N/C"}
                      </span>
                    </h4>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span className="text-sky-500">Date réception</span>
                        <span className="text-right text-gray-500">
                          {formatDate(dossier?.sinistres?.[0]?.dateCertificatImmat) || "N/C"}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sky-500">Convention</span>
                        <span className="text-right text-gray-500">
                          {dossier.horsConvention ? "Non" : "Oui"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Récapitulatif du dossier fin */}

            {/* Document début */}
            {/*<div className="bg-white rounded-xl shadow-sm p-4">*/}
            {/*  <div className="flex items-center justify-between mb-3">*/}
            {/*    <h4 className="font-semibold text-gray-900 text-sm">Documents</h4>*/}
            {/*    /!*<button className="text-green-600" onClick={() => fileInputRef.current.click()}>*!/*/}
            {/*    /!*  <IconPlus className="w-4 h-4"/>*!/*/}
            {/*    /!*</button>*!/*/}
            {/*    <input*/}
            {/*      type="file"*/}
            {/*      accept="image/png,image/jpeg,application/pdf,application/zip,application/x-rar-compressed"*/}
            {/*      ref={fileInputRef}*/}
            {/*      style={{display: "none"}}*/}
            {/*      onChange={handleFileChange}*/}
            {/*    />*/}
            {/*  </div>*/}
            {/*  <div className="space-y-2">*/}
            {/*    <div className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded-lg cursor-pointer">*/}
            {/*      <div className="w-7 h-7 bg-red-100 rounded flex items-center justify-center">*/}
            {/*        <span className="text-[10px] font-bold text-red-600">PDF</span>*/}
            {/*      </div>*/}
            {/*      <div className="flex-1 min-w-0">*/}
            {/*        <p className="text-xs font-medium text-gray-900 truncate">Carte_grise.pdf</p>*/}
            {/*        <p className="text-[10px] text-gray-500">245 Ko</p>*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    /!*<div className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded-lg cursor-pointer">*!/*/}
            {/*    /!*  <div className="w-7 h-7 bg-blue-100 rounded flex items-center justify-center">*!/*/}
            {/*    /!*    <span className="text-[10px] font-bold text-blue-600">IMG</span>*!/*/}
            {/*    /!*  </div>*!/*/}
            {/*    /!*  <div className="flex-1 min-w-0">*!/*/}
            {/*    /!*    <p className="text-xs font-medium text-gray-900 truncate">Photos_vehicule.zip</p>*!/*/}
            {/*    /!*    <p className="text-[10px] text-gray-500">4.2 Mo</p>*!/*/}
            {/*    /!*  </div>*!/*/}
            {/*    /!*</div>*!/*/}
            {/*  </div>*/}
            {/*</div>*/}
            {/* Document fin */}
          </div>
          {/* Side section fin */}
        </div>
      </div>
    </div>
  );
}

export default DossierGestionPage;